var dispatch = {
	lockBody: function() {
		$('body').addClass('lockScroll');
		$('body').css({ 'paddingRight': getScrollBarWidth() });
	},

	unlockBody: function() {
		$('body').removeClass('lockScroll');
		$('body').css({ 'paddingRight': 0 });
	},

	common: function () {
		// var scrollTop = parseInt($(window).scrollTop());
		// if (scrollTop !== 0) {
		// 	$("#mainHeader").addClass("sticky");
		// 	$('#backToTop').show();
		// }
		
		$(window).scroll(function () {
			var scrollTop = parseInt($(window).scrollTop());
			if (scrollTop !== 0) {
				$("#mainHeader").addClass("sticky");
				$('#backToTop').show();
			} else {
				$("#mainHeader").removeClass("sticky");
				$("#mainHeader").removeAttr("style");
				$('#backToTop').hide();
			}
		});

		$('#backToTop').click(function () {
			$('body, html').animate({ scrollTop: 0 }, 600);
		});

		$('.childMenu').click(function (e) {
			e.preventDefault()

			// $('.navigation__subNav').removeClass('open');
			$(this).parent().next().toggleClass('open');
		});

		// $('.sectionFirst__center ul li a').click(function (e) {
		// 	e.preventDefault();
		// 	$('html, body').animate({
		// 		scrollTop: $($(this).attr('href')).offset().top - 75
		// 	}, 500, 'linear');
		// });

		// Mobile Menu
		$('.menuHandle').click(function (e) {
			e.preventDefault();

			$("#mainHeader").find(".menuHandle").toggleClass("active");
			$("#mainHeader").find(".header__links").toggleClass("open");
		});
	},

	homePage: function () {
		// var settings = {
		// 	dots: false,
		// 	arrows: true,
		// 	prevArrow: '<button type="button" class="slick-prev"><img src="img/slider/slick-prev.png" alt=""></button>',
		// 	nextArrow: '<button type="button" class="slick-next"><img src="img/slider/slick-next.png" alt=""></button>',
		// 	speed: 500,
		// 	autoplay: true,
		// 	autoplaySpeed: 1500,
		// 	infinite: true,
		// 	slidesToShow: 1,
		// 	slidesToScroll: 1
		// };

		// $('.initSlider').slick(settings);

		// $('#sectionFirstTabs a[data-bs-toggle="tab"]').on('shown.bs.tab', function (e) {
		// 	var href = $(e.target).attr('href');
		// 	$('.initSlider').slick('destroy');
		// 	setTimeout(function () {
		// 		$(href + ' .initSlider').not('.slick-initialized').slick(settings);
		// 	}, 500)
		// });

		$('#ourServicesImagesSlider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: false,
			centerMode: true,
			focusOnSelect: true,
			asNavFor: '#ourServicesContentSlider'
		});

		$('#ourServicesContentSlider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			asNavFor: '#ourServicesImagesSlider',
			dots: false,
			arrows: true,
			prevArrow: '<button type="button" class="slick-prev"><img src="img/slick-prev.png" alt=""></button>',
			nextArrow: '<button type="button" class="slick-next"><img src="img/slick-next.png" alt=""></button>',
		});

		$('#ourClientsSlider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			arrows: true,
			adaptiveHeight: true,
			prevArrow: '<button type="button" class="slick-prev"><img src="img/slick-prev.png" alt=""></button>',
			nextArrow: '<button type="button" class="slick-next"><img src="img/slick-next.png" alt=""></button>',
		});

		(function () {
			var e = new ScrollMagic.Controller,
			top = TweenMax.staggerFromTo(["#scrollEffect .ourPartnersAwards__box--first", "#scrollEffect .ourPartnersAwards__box--eight", "#scrollEffect .ourPartnersAwards__box--third", "#scrollEffect .ourPartnersAwards__box--tenth", "#scrollEffect .ourPartnersAwards__box--fifth", "#scrollEffect .ourPartnersAwards__box--twelfth"], 1, {
				transform: "translate(0, -100px)"
			}, {
				transform: "translate(0, 0)",
				ease: Power2.easeOut
			}, .12),

			right = TweenMax.staggerFromTo(["#scrollEffect .ourPartnersAwards__box--second", "#scrollEffect .ourPartnersAwards__box--fourth", "#scrollEffect .ourPartnersAwards__box--sixth", "#scrollEffect .ourPartnersAwards__box--eighth", "#scrollEffect .ourPartnersAwards__box--tenth", "#scrollEffect .ourPartnersAwards__box--twelfth"], 1, {
				transform: "translate(100px, 0)"
			}, {
				transform: "translate(0, 0)",
				ease: Power2.easeOut
			}, .12),

			bottom = TweenMax.staggerFromTo(["#scrollEffect .ourPartnersAwards__box--seventh", "#scrollEffect .ourPartnersAwards__box--second", "#scrollEffect .ourPartnersAwards__box--ninth", "#scrollEffect .ourPartnersAwards__box--fourth", "#scrollEffect .ourPartnersAwards__box--eleventh", "#scrollEffect .ourPartnersAwards__box--sixth"], 1, {
				transform: "translate(0, 100px)"
			}, {
				transform: "translate(0, 0)",
				ease: Power2.easeOut
			}, .12),

			left = TweenMax.staggerFromTo(["#scrollEffect .ourPartnersAwards__box--first", "#scrollEffect .ourPartnersAwards__box--third", "#scrollEffect .ourPartnersAwards__box--fifth", "#scrollEffect .ourPartnersAwards__box--seventh", "#scrollEffect .ourPartnersAwards__box--ninth", "#scrollEffect .ourPartnersAwards__box--eleventh"], 1, {
				transform: "translate(-100px, 0)"
			}, {
				transform: "translate(0, 0)",
				ease: Power2.easeOut
			}, .12);

			new ScrollMagic.Scene({
				triggerElement: ".ourPartnersAwards",
				duration: 1000,
				offset: 0
			}).setTween(top).addTo(e),

			new ScrollMagic.Scene({
				triggerElement: ".ourPartnersAwards",
				duration: 1000,
				offset: 0
			}).setTween(right).addTo(e),

			new ScrollMagic.Scene({
				triggerElement: ".ourPartnersAwards",
				duration: 1000,
				offset: 0
			}).setTween(bottom).addTo(e),

			new ScrollMagic.Scene({
				triggerElement: ".ourPartnersAwards",
				duration: 1000,
				offset: 0
			}).setTween(left).addTo(e)
		})();
	},

	init: function () {
		this.common();
		this.homePage();
	}
};

$(".parallax").parallax();

$(document).ready(() => {
	$('body').addClass('lockScroll');
	$('body').css({ 'paddingRight': getScrollBarWidth() });
	dispatch.init();

	$(window).on('load', function () {
		if (!document.querySelector('.siteLoaderWrap')) return;
		setTimeout(() => {
			$('body').removeClass('lockScroll');
			$('body').css({ 'paddingRight': 0 });
			$('.siteLoaderWrap').hide();
		}, 0);
	});
});